import Menus from "../../../../config/app-menu.jsx";
import Form from "react-bootstrap/Form";

export default function AvailableMenus({ values, setFieldValue }) {
  // Función recursiva para obtener todos los paths (incluyendo hijos)
  const getAllChildrenPaths = (menu) => {
    let paths = [menu.path];
    if (menu.children) {
      menu.children.forEach((child) => {
        paths = [...paths, ...getAllChildrenPaths(child)];
      });
    }
    return paths;
  };

  // Función para encontrar el padre de un menú dado
  const findParent = (menus, childPath) => {
    for (const menu of menus) {
      if (menu.children?.some((c) => c.path === childPath)) {
        return menu; // encontramos al padre
      }
      if (menu.children) {
        const parent = findParent(menu.children, childPath);
        if (parent) return parent;
      }
    }
    return null;
  };

  const handleToggle = (menu, checked) => {
    let newMenus = [...(values.menus || [])];
    const paths = getAllChildrenPaths(menu);

    if (checked) {
      // Agregar el menú y todos sus hijos (sin duplicar)
      paths.forEach((p) => {
        if (!newMenus.includes(p)) newMenus.push(p);
      });

      // También agregar recursivamente los padres
      let parent = findParent(Menus, menu.path);
      while (parent) {
        if (!newMenus.includes(parent.path)) {
          newMenus.push(parent.path);
        }
        parent = findParent(Menus, parent.path);
      }
    } else {
      // Quitar el menú y todos sus hijos
      newMenus = newMenus.filter((p) => !paths.includes(p));
    }

    setFieldValue("menus", newMenus);
  };

  const renderMenus = (menus, level = 0) => (
    <div style={{ marginLeft: level * 40 }}>
      {menus.map((menu, i) => (
        <div key={i}>
          <Form.Check
            type="switch"
            label={menu.title}
            checked={values.menus?.includes(menu.path)}
            onChange={(e) => handleToggle(menu, e.target.checked)}
          />
          {menu.children && renderMenus(menu.children, level + 1)}
        </div>
      ))}
    </div>
  );

  return (
    <div>
      <h4>Asignar Menús al Rol</h4>
      {renderMenus(Menus)}
    </div>
  );
}
